import shortid from 'shortid'

export interface IManager {
  managerId: string,
  agencyCode: string,
  name: string,
  email: string,
  address: string,
  phone: string,
  managerQueue: string
}

export const initialManager: IManager =
{
  managerId: shortid.generate(),
  agencyCode: "",
  name: "",
  email: "",
  address: "",
  phone: "",
  managerQueue: ""
}

export enum ManagersTypes {
  ADMIN = 'Admin',
  CASEMANAGER = 'Case Manager',
  LAWENFORCEMENTAGENT = 'Law Enforcement Agent'
}

export const ManagerUserTypes = {
  [ManagersTypes.ADMIN]: 'ALL',
  [ManagersTypes.CASEMANAGER]: '',
  [ManagersTypes.LAWENFORCEMENTAGENT]: 'LEA'
}